import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { css, type CSSResult } from 'lit'

export const cseSkeleton = {
  borderRadius: css`var(--cse-skeleton-border-radius, ${csBorder.radiusMedium})`,
  minHeight: css`var(--cse-skeleton-min-height, 26px)`,
  backgroundColor: css`var(--cse-skeleton-background-color-primary, ${csColorBackground.primary})`,
  secondaryBackgroundColor: css`var(--cse-skeleton-background-color-secondary, ${csColorBackground.secondary})`,
}

export const style: CSSResult = css`
  @keyframes shimmer {
    to {
      opacity: 20%
    }
  }

  .cse-skeleton {
    border-radius: ${cseSkeleton.borderRadius};
    min-height: ${cseSkeleton.minHeight};
    background-color: ${cseSkeleton.backgroundColor};
    max-width: 100%;
    animation: shimmer 600ms infinite alternate;
    animation-delay: var(--delay, 0ms);
  }

  .variant-secondary {
    background-color: ${cseSkeleton.secondaryBackgroundColor};
  }
`
